import { ReactNode, useState } from 'react';

import { AuthFactoryContext } from './AuthFactoryContext';
import { UseAuthContextType } from './auth0/auth.types';
import { getDefaultUseAuthState } from './auth0/helpers';

export const MockAuthFactoryProvider = ({
  useAuthState = {},
  children,
}: {
  useAuthState?: Partial<UseAuthContextType>;
  children: ReactNode;
}) => {
  const [overrideToken, setOverrideToken] = useState<string | undefined>();
  const useAuth = () => getDefaultUseAuthState(useAuthState);

  return (
    <AuthFactoryContext.Provider
      value={{
        overrideToken,
        setOverrideToken,
        useAuth,
      }}
    >
      {children}
    </AuthFactoryContext.Provider>
  );
};

export const isTestEnvironment = () => {
  if (typeof window === 'undefined') return false;

  const win = window as any;
  return !!win.testEnvRuntime;
};
